import React, {Component} from 'react';
import {connect} from 'react-redux';
import validate from '../../utils/validate';

import * as spActions from '../../actions/sp';
import * as idpActions from '../../actions/idp';
import AppNames from "../AppNames/AppNames";
import DefaultNameId from "./DefaultNameId";
import ViewEntry from './ViewImport/ViewEntry';
import {UpdateExistingApplicationModal} from './ImportMetadata/UpdateExistingApplicationModal';
import {ExpiredMetadataCertificateModal} from './ImportMetadata/ExpiredMetadataCertificateModal';
import '../index.scss';
import {checkSession} from "../../api/api";
import * as messageConstants from '../../shared/messages';
import CapabilitiesSection from "./CapabilitiesSection";
import UserAttributes from "./UserAttributes/UserAttributes";
import UserGroupAttributes from "./UserGroupAttributes/UserGroupAttributes";
import Message from "../Message";
import IdpMetadataPopup from "./IdpMetadataPopup/IdpMetadataPopup";
import duplicates from 'array-duplicates';
import {MESSAGE_EVENT_TYPE} from "../../constants/postMessages";
import {SAML2_APPLICATION} from "../../constants/applicationTypes.js";
import * as samlConstants from '../../constants/samlConstants';
import {
  SID_GUID_FLEXIBLE_ATTRIBUTES,
  USER_EXTENDED_ATTRIBUTES,
  USER_GROUP_ATTRIBUTES
} from "../../constants/requiredCapabilitiesMapping";
import IdpCertificateMessage from "./CertificateExpirationBanner/IdpCertificateMessage";
import SpCertificateMessage from "./CertificateExpirationBanner/SpCertificateMessage";
import NewIdpCertificatePanel from "./NewIdPCertificate/NewIdpCertificatePanel";
import StartUsingNewIdpCertificateModal from "./NewIdPCertificate/StartUsingNewIdpCertificateModal";
import Moment from 'moment';
import * as consts from "../../constants/idpAdminConstants";
import {getExtendedAttributes, getMappedCapabilities} from "../../actions/storage";
import {EXTENDED_ATTRIBUTE, REGULAR_USER_ATTRIBUTES} from "../../constants/samlConstants";

export class AddSAML extends Component {
  state = {
    manualEntry: false,
    showSpNeeds: true,
    spDataActive: false,
    spData: undefined,
    errors: undefined,
    showModalUpdateExistingApplication: false,
  }
  handleFrameTasks = (e) => {
    console.log(e);
  }
  handleClearImport = () => {
    this.props.clearImportUrl();
  }
  handleSaveSP = () => {
    let metadata = null;

    if (this.props.importedMetadata && !this.state.spDataActive) {
      metadata = this.props.importedMetadata;
      metadata.defaultSamlNameIdFormatEnum = this.props.defaultSamlNameIdFormatEnum;
      if (this.props.defaultSamlNameIdFormatEnum
          === samlConstants.UNSPECIFIED) {
        metadata.unspecifiedNameIdFormatAttributeEnum = this.props.unspecifiedNameIdFormatAttributeEnum;
      } else {
        metadata.unspecifiedNameIdFormatAttributeEnum = samlConstants.UNSPECIFIED_NAME_ID_USER_PRINCIPAL_NAME
      }

      //Handle extended attributes
      let userAttributes = this.props.idpUserAttributes.map(o => {
        if (!REGULAR_USER_ATTRIBUTES.includes(o.idpUserAttributeEnum)) {
          return {
            userAttributeName: o.userAttributeName,
            userSpecifiedValue: o.idpUserAttributeEnum.toString(),
            idpUserAttributeEnum: EXTENDED_ATTRIBUTE
          }
        }
        return o;
      })

      metadata.idpUserAttributes = userAttributes.filter(
          e => e.userAttributeName.length > 0 && e.idpUserAttributeEnum.length
              > 0);
      metadata.idpUserGroupAttributes = this.props.idpUserGroupAttributes.filter(
          e => e.userGroupAttributeName.length > 0 && e.idpGroupAttributeFilterEnum.length
              > 0 && e.idpGroupAttributeFilterValue.length > 2);
    }

    const newMeta = {
      name: this.props.applicationName,
      userFriendlyName: this.props.userFriendlyName,
      applicationType: SAML2_APPLICATION,
      spSaml2Metadata: metadata,
      applicationId: this.props.applicationId
    }

    if (!newMeta.spSaml2Metadata.downloadUrl) {
      newMeta.spSaml2Metadata.downloadUrl = '';
    }

    const constraints = {
      name: {
        presence: {
          allowEmpty: false,
          message: messageConstants.SBA_WARNING_BLANK_APPNAME
        }
      },
      userFriendlyName: {
        presence: {
          allowEmpty: false,
          message: messageConstants.SBA_WARNING_BLANK_USER_FRIENDLY_APPNAME
        }
      },
      spSaml2Metadata: {
        presence: {
          allowEmpty: false,
          message: messageConstants.SBA_WARNING_BLANK_METADATA
        }
      },
    };
    const errors = validate(newMeta, constraints, {fullMessages: false});

    let idpUserGroupAttributeNames = this.props.idpUserGroupAttributes.length > 0
        ? this.props.idpUserGroupAttributes
        .map(o => o.userGroupAttributeName) : [];
    let idpUserAttributeNames = this.props.idpUserAttributes.length > 0
        ? this.props.idpUserAttributes
            .map(o => o.userAttributeName) : [];

    const duplicatedAttributes =
        duplicates(idpUserGroupAttributeNames.concat(idpUserAttributeNames).sort()).filter(i => i);
    if (errors) {
      this.setState({errors});
      this.props.setErrorMessage(errors[Object.keys(errors)[0]]);
    } else {
      if (!duplicatedAttributes.length > 0) {
        if (this.props.applicationId) {
          this.props.updateApp(newMeta, this.props.isApplicationReplaced);
        } else {
          this.props.addSp(newMeta);
        }
      } else {
        let message = duplicatedAttributes[0]
            + messageConstants.ATTRIBUTE_NAME_IS_DUPLICATED;
        this.props.setErrorMessage(message);
      }
    }
  }
  handleAddSamlCancelling = () => {
    this.props.cancelAddApp();
  }
  handleEditApplication = () => {
    if (this.props.match.params.applicationId && !this.props.importedMetadata) {
      this.props.editAppId(this.props.match.params.applicationId);
    }
  }
  handleRecoverExistingApplication = () => {
    this.setState({
      showModalUpdateExistingApplication: false,
    });
    this.props.recoverApp(this.props.duplicate);
  }
  handleReplaceExistingApplication = () => {
    this.props.replaceApp(this.props.importedMetadata, this.props.duplicate.id, this.props.duplicate.lastCertificateRotationDate);
    this.setState({
      showModalUpdateExistingApplication: false,
    })
  }
  handleCancelLoadExistingApplication = () => {
    this.setState({
      showModalUpdateExistingApplication: false,
    });
    this.handleClearImport();
  }
  handleUpdateDefaultNameId = (e) => {
    this.props.updateDefaultNameId(e.target.value);
  }
  handleUpdateUnspecifiedNameIdFormatAttribute = (e) => {
    this.props.updateUnspecifiedNameIdFormatAttribute(e.target.value);
  }
  handleChangeAppName = (e) => {
    this.props.updateAppname(e.target.value);
  }
  handleChangeUserFriendlyName = (e) => {
    this.props.updateUserFriendlyName(e.target.value)
  }
  handleUserFriendlyNameBlur = (e) => {
    if (!this.props.userFriendlyName.length > 0) {
      this.props.updateUserFriendlyName(this.props.applicationName)
    }
  }
  handleGetIdpMetadata = () => {
    this.props.getIdpMetadata();
  }
  handleShowModalIdpMetadata = () => {
    this.props.showIdpMetadataPopup();
  }
  handleHideModalIdpMetadata = () => {
    this.props.hideIdpMetadataPopup()
  }
  handleImportFromXml = (e) => {
    this.props.importFromXml(e);
  }
  handleImportFromUrl = (e) => {
    this.props.importFromUrl(e);
  }
  handleUpdateDownloadUrl = (e) => {
    this.props.updateDownloadUrl(e)
  }
  handleShowImportModalPopup = () => {
    this.props.showImportModalAction();
  }
  handleHideImportModalPopup = () => {
    this.props.hideImportModalPopup()
  }
  handleShowModalViewAllMetadata = () => {
    this.props.showModalViewAllMetadataPopup()
  }
  handleHideModalViewAllMetadata = () => {
    this.props.hideModalViewAllMetadataPopup()
  }
  handleChangeSelectedImportOption = (e) => {
    this.props.changeSelectedImportOption(e);
  }
  handleHideModalExpiredMetadataCertificate = () => {
    this.props.hideModalExpiredMetadataCertificate();
  }
  handleChooseOtherMetadata = () => {
    this.props.hideModalExpiredMetadataCertificate();
    this.props.showImportModalAction();
  }
  handleOpenHelpDocPage = (url) => {
    this.props.openHelpDocPage(url);
  }

  getIdpCertificateExpirationMessageType = () => {
    let messageType = null;
    if (this.props.idpCertificateValidTo && this.props.applicationId) {
      let currentDate = new Moment();
      let idpTransitionPeriodStart = this.props.idpCertificateValidTo.clone().subtract(consts.transitionPeriodForIdpCertificate, "days");
      let lastCertificateRotationDate =this.props.lastCertificateRotationDate;

      if ((currentDate.isAfter(idpTransitionPeriodStart) && !this.props.lastCertificateRotationDate)
        || (currentDate.isAfter(idpTransitionPeriodStart) && lastCertificateRotationDate.isBefore(idpTransitionPeriodStart))) {

        messageType = "Info";
      } else {
        messageType = "Success";
      }
    }
    return messageType;
  }

  handleStartUsingNewIdpCertificate = () => {
    this.props.startUsingNewIdpCertificate(this.props.applicationId)
  }

  componentDidMount() {
    if (checkSession(this.props.history)) {
      window.addEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
      this.handleGetIdpMetadata();
      this.handleEditApplication();
    }
  }

  componentDidUpdate() {
    if (this.props.duplicate
        && !this.state.showModalUpdateExistingApplication) {
      if (this.props.duplicate.id.toString()
          !== this.props.match.params.applicationId
          && this.props.duplicate.id
          !== this.props.applicationId) {
        this.setState({
          showModalUpdateExistingApplication: true
        })
      }
      else {
        this.handleReplaceExistingApplication()
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
  }

  render() {
    const capabilities = JSON.parse(getMappedCapabilities());
    const extendedAttributes = JSON.parse(getExtendedAttributes());
    const {idpUserAttributes} = this.props;
    const {idpUserGroupAttributes} = this.props;
    const displayFlexibleAttributes = capabilities ? capabilities[SID_GUID_FLEXIBLE_ATTRIBUTES] : false;
    const displayUserExtendedAttributes = capabilities ? capabilities[USER_EXTENDED_ATTRIBUTES] : false;
    const displayUserGroupAttributes = capabilities ? capabilities[USER_GROUP_ATTRIBUTES] : false;

    return (
        <div className="AddApp-container">
          <div className="container">
            <Message successMessage={this.props.successMsg}
                     errorMessage={this.props.errorMsg ? this.props.errorMsg
                         : this.props.idpErrorMsg}
                     clearMessages={this.props.clearMessages}/>
            <IdpCertificateMessage capabilities={capabilities}
                                   applicationId={this.props.applicationId}
                                   messageType={this.getIdpCertificateExpirationMessageType()}
                                   expirationDate={this.props.idpCertificateValidTo}
                                   newExpirationDate={this.props.newIdpCertificateValidTo}
                                   handleOpenHelpDocPage={this.handleOpenHelpDocPage}/>
            <SpCertificateMessage messageType={this.props.spCertificateExpirationMessageType}
                                  expirationDate={this.props.spCertificateValidTo}
                                  handleReplaceMetadata={this.handleShowImportModalPopup}/>

            <div className="row">
              <div className="col-xs-12 col-sm-8 col-md-8">
                <div className="add-edit-title">{this.props.applicationId
                    ? messageConstants.SBA_TITLE_EDIT
                    : messageConstants.SBA_TITLE_ADD}</div>
                <div className="add-edit-subtitle">
                  {messageConstants.SBA_SUBTITLE}
                </div>

                <AppNames applicationName={this.props.applicationName}
                          userFriendlyName={this.props.userFriendlyName}
                          handleChangeAppName={this.handleChangeAppName}
                          handleChangeUserFriendlyName={this.handleChangeUserFriendlyName}
                          handleUserFriendlyNameBlur={this.handleUserFriendlyNameBlur}/>


                <ViewEntry
                    metadata={this.props.importedMetadata}
                    downloadUrl={this.props.downloadUrl}
                    showImportModal={this.props.showImportModal}
                    handleUpdateDownloadUrl={this.handleUpdateDownloadUrl}
                    selectedImportOption={this.props.selectedImportOption}
                    handleChangeSelectedImportOption={this.handleChangeSelectedImportOption}
                    handleImportFromXml={this.handleImportFromXml}
                    handleImportFromUrl={this.handleImportFromUrl}
                    handleShowImportModal={this.handleShowImportModalPopup}
                    handleHideImportModal={this.handleHideImportModalPopup}
                    showModalViewAllMetadata={this.props.showModalViewAllMetadata}
                    handleShowModalViewAllMetadata={this.handleShowModalViewAllMetadata}
                    handleHideModalViewAllMetadata={this.handleHideModalViewAllMetadata}
                    onClear={this.handleClearImport}
                />

                <DefaultNameId
                    importedMetadata={this.props.importedMetadata}
                    defaultSamlNameIdFormatEnum={this.props.defaultSamlNameIdFormatEnum}
                    unspecifiedNameIdFormatAttributeEnum={this.props.unspecifiedNameIdFormatAttributeEnum}
                    displaySidOption={displayFlexibleAttributes}
                    handleUpdateDefaultNameId={this.handleUpdateDefaultNameId}
                    handleUpdateUnspecifiedNameIdFormatAttribute={this.handleUpdateUnspecifiedNameIdFormatAttribute}/>

                <CapabilitiesSection
                    capabilities={capabilities}
                >
                  <UserAttributes
                      idpUserAttributes={idpUserAttributes}
                      extendedAttributes={extendedAttributes}
                      displayUserExtendedAttributes={displayUserExtendedAttributes}
                      displayFlexibleAttributes={displayFlexibleAttributes}
                      handleAddUserAttribute={this.props.addUserAttribute}
                      handleDelUserAttribute={this.props.deleteUserAttribute}
                      handleUpdateUserAttributes={this.props.updateUserAttributes.bind(
                          this)}/>
                  <UserGroupAttributes
                      idpUserGroupAttributes={idpUserGroupAttributes}
                      displayUserGroupAttributes={displayUserGroupAttributes}
                      handleAddUserGroupAttribute={this.props.addUserGroupAttribute}
                      handleDelUserGroupAttribute={this.props.deleteUserGroupAttribute}
                      handleUpdateUserGroupAttributes={this.props.updateUserGroupAttributes.bind(
                          this)}/>
                </CapabilitiesSection>

                <h3 className="sba-subtitle">{messageConstants.SBA_METADATA_REQUIRED_SP}
                </h3>

                <div className="add-edit-subtitle">
                  {messageConstants.SBA_SAML_METADATA_REQUIRED_SP_DESCRIPTION}
                </div>
                {
                  (this.props.applicationId && this.getIdpCertificateExpirationMessageType() === "Info") ? (
                      <NewIdpCertificatePanel
                          newIdpMetadataButtonText={messageConstants.NEW_SAML_IDP_METADATA_VIEW_AND_COPY_BUTTON}
                          showIdpMetadataPopup={this.handleShowModalIdpMetadata}
                          showStartUsingNewIdpCertificatePopup={this.props.showModalStartUsingNewIdpCertificate}
                      />
                  ) : (
                      <div className="view-idp-metadata-block">
                        <button id="showModalIdpMetadataButton"
                                className="btn btn-link view-idp-metadata-button"
                                onClick={this.handleShowModalIdpMetadata}>{messageConstants.IDP_VIEW_AND_COPY_METADATA}
                        </button>
                      </div>
                  )
                }
                <IdpMetadataPopup
                    showModalIdpMetadata={this.props.showModalIdpMetadata}
                    handleHideModalIdpMetadata={this.handleHideModalIdpMetadata}
                    idpMetadata={this.props.idpMetadata}
                    idpMetadataXmlProp={this.props.idpMetadataXmlProp}
                />

                <div className="action-row">
                  <button
                      id="cancelSaveSbaApplicationButton"
                      type="button"
                      className="btn btn-md cancel-save-button"
                      disabled={this.state.manualEntry}
                      onClick={this.handleAddSamlCancelling}
                  >
                    {messageConstants.CANCEL}
                  </button>
                  &nbsp;
                  <button
                      id="saveSbaApplicationButton"
                      type="button"
                      className="btn btn-md btn-primary save-button"
                      disabled={!this.props.applicationName
                      || !this.props.importedMetadata}
                      onClick={this.handleSaveSP}
                  >
                    {messageConstants.SBA_SAVE_BUTTON}
                  </button>
                </div>
                <div>
                  <UpdateExistingApplicationModal
                      handleRecoverExistingApplication={this.handleRecoverExistingApplication}
                      handleReplaceExistingApplication={this.handleReplaceExistingApplication}
                      showModalUpdateExistingApplication={this.state.showModalUpdateExistingApplication}
                      handleCancelLoadExistingApplication={this.handleCancelLoadExistingApplication}
                      entityId={this.props.duplicate
                          ? this.props.duplicate.spSaml2Metadata.entityId : ""}
                      existingAppName={this.props.duplicate
                          ? this.props.duplicate.name : ""}/>
                </div>
                <div>
                  <ExpiredMetadataCertificateModal
                      modalExpiredMetadataCertificateIsShown={this.props.modalExpiredMetadataCertificateIsShown}
                      handleHideModalExpiredMetadataCertificate={this.handleHideModalExpiredMetadataCertificate}
                      handleChooseOtherMetadata={this.handleChooseOtherMetadata}
                  />
                </div>
                <div>
                  <StartUsingNewIdpCertificateModal
                      showModalStartUsingNewIdpCertificate={this.props.modalStartUsingNewIdpCertificateIsShown}
                      handleHideModalStartUsingNewIdpCertificate={this.props.hideModalStartUsingNewIdpCertificate}
                      handleStartUsingNewIdpCertificate={this.handleStartUsingNewIdpCertificate}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    credentials: state.auth.credentials,
    errorMsg: state.sp.errorMsg,
    idpErrorMsg: state.idp.errorMsg,
    importedMetadata: state.sp.importMetadata,
    idpUserAttributes: state.sp.idpUserAttributes,
    idpUserGroupAttributes: state.sp.idpUserGroupAttributes,
    applicationId: state.sp.applicationId,
    applicationName: state.sp.applicationName,
    userFriendlyName: state.sp.userFriendlyName,
    duplicate: state.sp.duplicate,
    defaultSamlNameIdFormatEnum: state.sp.defaultSamlNameIdFormatEnum,
    unspecifiedNameIdFormatAttributeEnum: state.sp.unspecifiedNameIdFormatAttributeEnum,
    idpMetadata: state.idp,
    downloadUrl: state.sp.downloadUrl,
    selectedImportOption: state.sp.selectedImportOption,
    showModalIdpMetadata: state.idp.showModalIdpMetadata,
    showImportModal: state.sp.showImportModal,
    showModalViewAllMetadata: state.sp.showModalViewAllMetadata,
    modalExpiredMetadataCertificateIsShown: state.sp.modalExpiredMetadataCertificateIsShown,
    spCertificateExpirationMessageType: state.sp.spCertificateExpirationMessageType,
    spCertificateValidTo: state.sp.certificateValidTo,
    idpCertificateValidTo: state.idp.certificateValidTo,
    newIdpCertificateValidTo: state.idp.newCertificateValidTo,
    lastCertificateRotationDate: state.sp.lastCertificateRotationDate,
    modalStartUsingNewIdpCertificateIsShown: state.sp.modalStartUsingNewIdpCertificateIsShown,
    isApplicationReplaced: state.sp.isApplicationReplaced
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAppname: (e) => {
      dispatch(spActions.updateAppName(e))
    },
    updateUserFriendlyName: (e) => {
      dispatch(spActions.updateUserFriendlyName(e))
    },
    updateDefaultNameId: (e) => {
      dispatch(spActions.updateDefaultNameId(e))
    },
    updateUnspecifiedNameIdFormatAttribute: (e) => {
      dispatch(spActions.updateUnspecifiedNameIdFormatAttribute(e))
    },
    clearImportUrl: () => {
      dispatch(spActions.clearImportUrl());
    },
    addSp: (metadata) => {
      dispatch(spActions.addSp(metadata));
    },
    updateApp: (metadata, isApplicationReplaced) => {
      if (isApplicationReplaced) {
        dispatch(spActions.startUsingNewIdpCertificate(metadata.applicationId));
        dispatch(spActions.updateApp(metadata));
      } else {
        dispatch(spActions.updateApp(metadata));
      }
    },
    cancelAddApp: () => {
      dispatch(spActions.cancelAddApp());
    },
    editAppId: (applicationId) => {
      dispatch(spActions.getApp(applicationId))
    },
    addUserAttribute: () => {
      dispatch(spActions.addUserAttribute());
    },
    deleteUserAttribute: (attribute) => {
      dispatch(spActions.deleteUserAttribute(attribute));
    },
    updateUserAttributes: (evt) => {
      dispatch(spActions.updateUserAttributes(evt));
    },
    addUserGroupAttribute: () => {
      dispatch(spActions.addUserGroupAttribute());
    },
    deleteUserGroupAttribute: (attribute) => {
      dispatch(spActions.deleteUserGroupAttribute(attribute));
    },
    updateUserGroupAttributes: (evt) => {
      dispatch(spActions.updateUserGroupAttributes(evt));
    },
    recoverApp: (payload) => {
      dispatch(spActions.recoverApp(payload));
    },
    replaceApp: (payload, appId, lastCertificateRotationDate) => {
      dispatch(spActions.replaceApp(payload, appId, lastCertificateRotationDate));
    },
    clearMessages: () => {
      dispatch(spActions.clearMessages())
    },
    setErrorMessage: (errorMessage) => {
      dispatch(spActions.setErrorMessage(errorMessage))
    },
    getIdpMetadata: () => {
      dispatch(idpActions.getIdpMetadata());
    },
    idpMetadataXmlProp: () => {
      dispatch(idpActions.downloadIdpMetadataXml());
    },
    updateDownloadUrl: (e) => {
      dispatch(spActions.updateDownloadUrl(e))
    },
    showIdpMetadataPopup: () => {
      dispatch(idpActions.showIdpMetadataPopup());
    },
    hideIdpMetadataPopup: () => {
      dispatch(idpActions.hideIdpMetadataPopup());
    },
    changeSelectedImportOption: (e) => {
      dispatch(spActions.changeSelectedImportOption(e));
    },
    importFromXml: (file) => {
      dispatch(spActions.importFromXml(file));
    },
    importFromUrl: (url) => {
      dispatch(spActions.importUrl(url));
    },
    showImportModalAction: () => {
      dispatch(spActions.showImportModalPopup());
    },
    hideImportModalPopup: () => {
      dispatch(spActions.hideImportModalPopup());
    },
    showModalViewAllMetadataPopup: () => {
      dispatch(spActions.showModalViewAllMetadata());
    },
    hideModalViewAllMetadataPopup: () => {
      dispatch(spActions.hideModalViewAllMetadata());
    },
    hideModalExpiredMetadataCertificate: () => {
      dispatch(spActions.hideModalExpiredMetadataCertificate());
    },
    openHelpDocPage: (url) => {
      dispatch(spActions.openHelpDocPage(url));
    },
    showModalStartUsingNewIdpCertificate: () => {
      dispatch(spActions.showModalStartUsingNewIdpCertificate())
    },
    hideModalStartUsingNewIdpCertificate: () => {
      dispatch(spActions.hideModalStartUsingNewIdpCertificate())
    },
    startUsingNewIdpCertificate: (applicationId) => {
      dispatch(spActions.startUsingNewIdpCertificate(applicationId))
    }
  }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddSAML);
